import { useAuth } from "@/lib/auth";
import { useBranding } from "@/lib/branding";

export default function AccessDenied() {
  const { signOut } = useAuth();
  const { branding, primaryLogoSrc } = useBranding();
  const displayName = branding?.identity?.display_name || "Coolman Fuels";
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f3f4f6] px-4">
      <div className="w-full max-w-md border border-gray-200 bg-white p-8 text-center shadow-sm">
        <img src={primaryLogoSrc()} alt={displayName} className="mx-auto h-16 w-auto" data-testid="access-denied-logo" />
        <h1 className="mt-4 text-2xl font-semibold text-[#EB1D25]">Access Denied</h1>
        <p className="mt-3 text-[15px] text-gray-700">
          You have been authenticated with Microsoft, but your account has not been granted access to {displayName} Order Centre.
        </p>
        <p className="mt-2 text-sm text-gray-600">
          Please contact an administrator to be added to the Users table.
        </p>
        <button
          data-testid="signout-button"
          onClick={signOut}
          className="mt-6 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Sign out and try a different account
        </button>
      </div>
    </div>
  );
}
